<template lang="html">
  <scroll
    :listenScroll="listenScroll"
    :probe-type="scrollProbeType"
    ref="aboutUs">
    <div class="">
      <div class="">
        <img v-lazy="aboutUsData.coverImg" alt="" class="move cover-img">
      </div>
      <div class="detail">
        <div class="">
          <div class="top">
            <h1>{{aboutUsData.detail.title}}</h1>
          </div>
          <div class="detail-box">
            <p>
              {{aboutUsData.detail.content}}
            </p>
          </div>
        </div>
      </div>
      <div class="title">
        <div class="top">
          <h1>企业文化</h1>
        </div>
      </div>
      <div class="swp">
        <slide class="nav-se"
        :probe-type="slideProbeType"
        :scrollX="slideXFlag"
        :scrollY="slideYFlag"
        :data="aboutUsData.detail.imgList"
        ref="abusWrap">
        <ul class="abus" ref="abus">
          <li v-for="(item, index) in aboutUsData.detail.imgList" :key="index">
            <img v-lazy="item.img" alt="">
          </li>
        </ul>
      </slide>
    </div>
      <div class="history">
        <div class="">
          <div class="top">
            <h1>发展历史</h1>
          </div>
          <div class="">
            <ul class="history-detail">
              <li v-for="(item, index) in aboutUsData.history" :key="index">
                <div class="lf">
                  {{item.time}}
                </div>
                <div class="rt">
                  <img v-lazy="item.bakImg" alt="">
                  <ul>
                    <li v-for="(inItem, inIndex) in item.detail" :key="inIndex">{{inItem.item}}</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <m-footer></m-footer>
    </div>
  </scroll>
</template>

<script>
import Scroll from 'base/scroll/scroll'
import Slide from 'base/slide/slide'
import MFooter from 'components/ter/footer/footer'
import 'common/ter/stylus/base.styl'
import aboutUsData from 'common/ter/js/aboutUs'
// import {navShowMixin} from 'common/js/mixin'
export default {
  // mixins: [navShowMixin],
  created () {
    this.slideProbeType = 3
    this.scrollProbeType = 2
    this.aboutUsData = aboutUsData
  },
  data () {
    return {
      aboutUsData: null,
      slideXFlag: true,
      slideYFlag: false,
      listenScroll: true
    }
  },
  components: {
    Slide,
    MFooter,
    Scroll
  },
  mounted () {
    setTimeout(() => {
      this._initNav()
    }, 30)
  },
  methods: {
    _initNav () {
      // 横向滚动 宽度
      // let w = 0
      // Array.prototype.forEach.call(this.$refs.abus.children, (v, i) => {
      //   console.log(v.clientWidth)
      //   w += v.clientWidth
      // })
      let w = document.body.clientWidth / 375 * 150 * 3
      this.$refs.abus.style.width = `${w}px`
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import "~common/ter/stylus/media"
.title
  padding-left: 10px
  padding-bottom: 5px
img
  width: 100%
.cover-img
  set-height(300)
.swp
  width: 100%
  overflow: hidden
  background-color: #F5F5F5
  .top
    padding-left: 20px
    margin-top: 18px
    margin-bottom: 0
    &:after
      left: 10px
  ul:after
    content: ''
    clear: both
  li
    set-width(150)
    float: left
    padding: 15px 0 15px 5px
    &:first-child
      padding-left: 10px
    &:last-child
      padding-left: 0px
    img
      set-width(135)
      set-height(90)
      display: block
.detail, .history
  padding: 20px 10px 20px
.top
  position: relative
  margin-bottom: 5px
  padding-left: 10px
  h1
    font-size: 14px
    color: #007CE5
  &:after
    content: ''
    width: 4px
    height: 10px
    position: absolute
    left: 0
    top: 3px
    background-color: #007CE5
.detail-box
  p
    line-height: 1.8
    font-size: 12px
    color: #333
.history-detail
  overflow: hidden
  &>li
    width: calc(50% - 6px)
    float: left
    display: flex
    margin-bottom: 12px
    img
      height: 100%
    &:nth-of-type(2n)
      margin-left: 6px
    &:nth-of-type(2n-1)
      margin-right: 6px
    .lf
      display: flex
      justify-content: center
      flex: 0 0 28px
      font-size: 9px
      background-color: #007CE5
      color: #fff
      display: flex
      align-items: center
      writing-mode: vertical-lr
      writing-mode: tb-lr
      font-weight: bolder
    .rt
      position: relative
      flex: 1
    ul
      width: 100%
      height: 100%
      position: absolute
      left: 0
      top: 0
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      text-align: left
      li
        width: 100%
        position: relative
        padding: 2px 2px 2px 10px
        font-size: 9px
        color: #333
        &:after
          content: ''
          width: 3px
          height: 3px
          position: absolute
          left: 5px
          top: 5px
          border-radius: 50%
          background-color: #007CE5
  &:after
    content: ''
    clear: both
</style>



// WEBPACK FOOTER //
// src/components/ter/aboutUs/aboutUs.vue